import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default () => {
	const hasFeature = useFeatureAvailable(Feature.PROJECT_PLAN);
	return hasFeature;
};
